import { FormControl, MenuItem, Select, SelectProps } from "@mui/material"

type YearSelectProps = {
	list: string[]
} & SelectProps<string>
export const YearSelect = ({
	list,
	...others
}: YearSelectProps) => {
	return (
		<FormControl fullWidth>
			<Select {...others}>
				{list.map(year => (
					<MenuItem key={`year_${year}`} value={`${year}`}>
						{year} 年
					</MenuItem>
				))}
			</Select>
		</FormControl>
	)
}
